import React from 'react';

import Localization from "../Localization.jsx";

/**
 * Loading placeholders for the list surfaces (locale cards, hotspot rows,
 * component rows).
 *
 * Those lists only ever distinguished "has rows" from "no rows", so a fetch
 * still in flight rendered the empty-state artwork — the user was told there
 * was nothing there before the server had answered. These placeholders make the
 * third state visible: grey rounded blocks with the same pulsing three dots the
 * admin tables use, meaning "not known yet".
 */

/** One grey rounded block with the three pulsing dots centred inside it. */
export function ListLoadingBlock({ height = 72, radius, style }) {
  return (
    <div
      className="list-loading-block"
      style={{ height, ...(radius == null ? null : { borderRadius: radius }), ...style }}
    >
      <span className="table-loading-dot" />
      <span className="table-loading-dot" />
      <span className="table-loading-dot" />
    </div>
  );
}

/** `count` blocks stacked vertically, for the single-column lists. */
export default function ListLoadingPlaceholder({
  count = 3,
  height = 72,
  gap = 10,
  radius,
  blockStyle,
  style,
}) {
  const blocks = [];
  for (let i = 0; i < count; i++) {
    blocks.push(<ListLoadingBlock key={i} height={height} radius={radius} style={blockStyle} />);
  }

  return (
    <div
      className="list-loading-stack"
      style={{ gap, ...style }}
      role="status"
      aria-live="polite"
      aria-label={Localization.strings.LOADING_DATA}
    >
      {blocks}
    </div>
  );
}
